{
  "title": "¿Permitir acceso a tu ubicación?",
  "body": "Al permitir el acceso a tu ubicación, podemos asegurarnos de que llegaste a la instalación para el registro",
  "disagree": "No acepto",
  "agree": "Acepto"
}
